import React, { useState, useEffect } from "react";
import "./IntroApp.css";
import animalKennyImage from "./assets/animalkenny.png";

const IntroApp = () => {
  const fullText =
    "hi, im kenny. welcome to my portfolio! click the red button to exit and learn more about me through the applications on the left(:";
  const [displayedText, setDisplayedText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (currentIndex < fullText.length) {
      const timeout = setTimeout(() => {
        setDisplayedText((prev) => prev + fullText[currentIndex]);
        setCurrentIndex((prev) => prev + 1);
      }, 60); // Adjust speed here (lower = faster)

      return () => clearTimeout(timeout);
    }
  }, [currentIndex, fullText]);

  return (
    <div className="intro-app">
      <div className="intro-content">
        <h1>{displayedText}</h1>
      </div>
      <img src={animalKennyImage} alt="Kenny" className="intro-image" />
    </div>
  );
};

export default IntroApp;
